import React from "react";
import { useNavigate } from "react-router-dom";

import { images } from "../../constants";

import "./ErrorFallBack.scss";

const ErrorFallBack = (props: any) => {
  const navigate = useNavigate();

  return (
    <div className="error-page">
      <div className="error-container">
        <img src={images.error} alt="error" />
        <div>
          <h1>Something went wrong</h1>
          <button onClick={() => navigate("/")}>Home</button>
        </div>
      </div>
    </div>
  );
};

export default ErrorFallBack;
